import { ReactNode } from "react";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import useTheme from "@mui/material/styles/useTheme";

import { colord } from "colord";

import { misc } from "app/themes/colors";

import { BALANCE_PRIVATE_MODE_SX } from "./balance-display.component";

type PatientResponsibilityBalanceDisplayProps = {
  totalBalanceColor: string;
  color: string;
  text: string;
  expanderContent?: ReactNode;
  isPrivateMode?: boolean;
  anchorEl?: HTMLElement | null;
  handleHideBalanceExpander: () => void;
  handleShowBalanceExpander: (event: React.MouseEvent<HTMLDivElement>) => void;
};

export default function PatientResponsibilityBalanceDisplay({
  color,
  text,
  expanderContent,
  anchorEl,
  isPrivateMode,
  handleShowBalanceExpander,
  handleHideBalanceExpander
}: PatientResponsibilityBalanceDisplayProps) {
  const { palette } = useTheme();
  const contrastColor = colord(
    palette.getContrastText(colord(color).darken(0.05).toHex())
  )
    .alpha(0.2)
    .toHex();
  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        px: 0.5,
        py: 0.1,
        background: color,
        borderRadius: "5px",
        border: `solid 1px ${contrastColor}`,
        boxShadow: "2px 2px 2px 0px rgba(0,0,0,0.15)"
      }}
    >
      <Stack
        direction="row"
        sx={{
          justifyContent: "space-between",
          display: "flex",
          alignItems: "center",
          fontSize: `14px`
        }}
      >
        <Box sx={{ pr: 1 }}>Patient</Box>

        {Boolean(expanderContent) && (
          <Box
            sx={{
              cursor: "pointer",
              height: "16px",
              width: "16px",
              px: 0,
              py: 0,
              background: misc.mutedPurple,
              borderRadius: "50%",

              zIndex: 1
            }}
            onClick={(event) => {
              if (Boolean(anchorEl)) {
                handleHideBalanceExpander();
              } else {
                handleShowBalanceExpander(event);
              }
            }}
          >
            {!Boolean(anchorEl) ? (
              <KeyboardArrowDownIcon
                sx={{ ml: -0.4, mt: -0.4, fontSize: "22px" }}
              />
            ) : (
              <KeyboardArrowUpIcon
                sx={{ ml: -0.4, mt: -0.4, fontSize: "22px" }}
              />
            )}
          </Box>
        )}
      </Stack>

      <Typography
        fontSize="14px"
        data-testid="sale-balance-value"
        data-color={color}
        textAlign="right"
        width="100%"
        pl={1}
        sx={isPrivateMode ? BALANCE_PRIVATE_MODE_SX : {}}
      >
        {text}
      </Typography>
    </Stack>
  );
}
